import * as React from 'react';
import { ComponentProps } from 'react';
import { connect } from 'react-redux';
import CoreSelectedFlight from '@websky/core/src/Checkout/components/Checkout/SelectedFlight/SelectedFlight';
import { CheckoutState } from '@websky/core/src/Checkout/store/reducers';
import { getOrder } from '@websky/core/src/Checkout/store/order/selectors';
import css from './SelectedFlight.css';
import cn from 'classnames';
import * as utils from '../CurrencyWarning/utils';
import CurrencyWarning from '../CurrencyWarning/CurrencyWarning';

const SelectedFlight: React.FC<ComponentProps<typeof CoreSelectedFlight>> = props => {
	const showNote = utils.needShowWarning(props.order.priceToPay.total);

	return (
		<div className={cn(css.selectedFlight_wrapper, { [css.priceWithNote]: showNote })}>
			<CoreSelectedFlight {...props} />
			{showNote && (
				<div className={css.currencyWarning_wrapper}>
					* <CurrencyWarning total={props.order.priceToPay.total} />
				</div>
			)}
		</div>
	);
};

const mapStateToProps = (state: CheckoutState) => ({
	order: getOrder(state)
});

export default connect(mapStateToProps)(SelectedFlight) as React.FC<ComponentProps<typeof CoreSelectedFlight>>;
